import { compile } from 'path-to-regexp';
import queryString from 'query-string';
import React, { forwardRef } from 'react';

import { nuiCtx } from '../initialization';
import { NikeRoute } from './types';

// route or routePath is mandatory

interface RouteLinkProps {
    route?: NikeRoute;
    routePath?: string;
    params?: Record<string, any>;
    searchParams?: Record<string, any>;
    children?: React.ReactNode;
    beforeNavigate?: () => Boolean;
    enabled?: Boolean;
    onClick?: () => any;
    [x: string]: any;
}
const RouteLink = forwardRef<HTMLAnchorElement, RouteLinkProps>(
    ({ route, routePath, params, searchParams, children, beforeNavigate, enabled = true, onClick, ...rest }, ref) => {
        routePath = routePath || route?.path || '#';
        const href =
            decodeURIComponent(compile(routePath)(params)) +
            (searchParams ? '?' + queryString.stringify(searchParams) : '');
        const { routes, navigate } = nuiCtx.routing;
        const onClickInner = onClick
            ? onClick
            : e => {
                  if (!enabled || (beforeNavigate && !beforeNavigate())) {
                      e.preventDefault();
                      e.stopPropagation();
                      return;
                  }
                  let _route = route || routes.find(r => r.path === routePath);
                  if (_route) {
                      navigate(_route, params, searchParams);
                      if (href) {
                          e.preventDefault();
                          e.stopPropagation();
                      }
                  }
              };
        return (
            <a href={href} onClick={onClickInner} {...rest} ref={ref}>
                {children}
            </a>
        );
    }
);

export default RouteLink;
